"use client"

export const AboutHero = () => {
  return (
    <section className="relative bg-white border-b-8 border-amber-500 pt-24 pb-8 animate-in fade-in duration-700">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:py-16">
        <div className="text-center border-b-4 border-amber-800 pb-8 mb-10 animate-in slide-in-from-top duration-700">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm mb-4 font-semibold shadow-sm">
            <span className="w-2 h-2 bg-amber-600 rounded-full animate-pulse"></span>
            Est. 1999 • Manila, Philippines
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-gray-900 tracking-tight mb-4">
            Travel Warehouse Inc.
          </h1>
          <div className="text-lg sm:text-xl md:text-2xl text-gray-700 italic font-medium">Your Trusted Travel Partner Since 1999</div>
        </div>

        <div className="max-w-4xl mx-auto mb-8">
          <div className="animate-in slide-in-from-left duration-700" style={{ animationDelay: '200ms' }}>
            <div className="border-l-4 border-orange-500 pl-6 mb-6">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-3">
                Years of Unforgettable Travel Experiences
              </h2>
              <div className="flex items-center gap-2 text-sm text-orange-600 uppercase tracking-wide font-semibold">
                <span className="w-8 h-0.5 bg-orange-500"></span>
                Special Feature
              </div>
            </div>
            <div className="space-y-6">
              <p className="text-base sm:text-lg md:text-xl leading-relaxed text-gray-700 text-justify">
                <span className="font-bold text-3xl float-left mr-0.5 leading-none text-amber-600">T</span>
                ravel Warehouse, Inc. has been at the forefront of the Philippine travel industry for over two decades,
                dedicated to providing exceptional travel planning services that transform ordinary trips into
                extraordinary adventures. We craft unforgettable journeys tailored to your unique preferences and desires.
              </p>
              <p className="text-base sm:text-lg md:text-lg leading-relaxed text-gray-700">
                From humble beginnings as a small travel agency in Manila, we have grown into one of the most trusted
                names in Philippine tourism, serving thousands of satisfied customers and creating memories that last a
                lifetime.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
